// Module
var code = `<div id="sidebar">
  <!--
<h3>The sidebar menu content</h3>
--></div>
`;
// Exports
module.exports = code;